import { gql } from '__generated__';

export const ASK_SUPPORT_ASSISTANT = gql(/* GraphQL */ `
  mutation AskSupportAssistant($input: AskSupportAssistantInput!) {
    askSupportAssistant(input: $input) {
      success
      answer
      error
      conversationId
      citations {
        url
        urlPath
        title
        heading
      }
    }
  }
`);
